module.exports = __webpack_public_path__ + "img/newsIcon.21420142.png";